import { Box } from "../Box";
import { DateRangePicker } from "../DateRangePicker/index";
import { Paragraph } from "../Paragraph";
import { Slider } from "../Slider";
import { Form, Formik } from "formik";
import Select from "../Select";
import { Button } from "../Button";
import { capitalise } from "../../utils/string";
import { Flex } from "../Flex";
import { useMonitoringStatus } from "../../data/useMonitoringStatus";
import { monitoringView } from "../../hooks/dashboardViews/monitoring";

type FiltersProps = {
  isOpen?: boolean;
  onRequestClose: () => void;
  filters: any;
  onSubmit: (values: any) => void;
};

// Derived from the view schema's own defaults so the panel's "Clear All"
// and the chip bar's "Clear all" can never disagree (tech spec 7.1). This
// also fixes the pre-existing gap where Clear All left status undefined
// instead of returning it to "all" (tech spec 4.5).
const { fields } = monitoringView;
const initialState = {
  status: fields.status.default,
  created_on_date: [fields.createdOnFrom.default, fields.createdOnTo.default],
  last_activity_date: [fields.lastActivityFrom.default, fields.lastActivityTo.default],
};

export const MonitoringDateFilters = (props: FiltersProps) => {
  const { isOpen, onRequestClose, onSubmit, filters } = props;
  const { data } = useMonitoringStatus();
  const statusOptions = data?.data?.map(
    ({id, status }) => ({
      value: id,
      label: `${status}`,
    })
  );


  return (
    <Slider isOpen={isOpen} onRequestClose={onRequestClose}>
      <Box p={3} overflowY="auto" height={"calc(100vh - 211px)"}>
        <Formik
          initialValues={filters}
          onSubmit={(values, helpers) => {
            onSubmit(values);
            helpers.resetForm({ values });
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Paragraph as="h2" fontSize={3} mt="0px" display="flex">
                Filters
                <Button
                  type="reset"
                  px={2}
                  variant="text"
                  size="small"
                  position="absolute"
                  top="26px"
                  right="75px"
                  onClick={() => {
                    props.resetForm({ values: initialState });
                    props.submitForm();
                  }}
                >
                  Clear All
                </Button>
              </Paragraph>
              <Select
                  onChange={(option: any) => {
                    props.setFieldValue("status", option.value);
                  }}
                  getOptionLabel={(options) => {
                    return (
                      <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        position="relative"
                        width={"100%"}
                      >
                        <span>
                          {capitalise(options.label)}
                        </span>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          position="relative"
                        >
                        </Flex>
                      </Flex>
                    );
                  }}
                  value={
                    statusOptions?.find(
                      ({ value }) => value === props.values.status
                    ) || { label: "All", value: "all" }
                  }
                  options={statusOptions}
                  placeholder="Select status"
                  label="Status"
                  name="status"
                />

              <DateRangePicker
                value={props.values.created_on_date}
                onChange={(option: any) =>
                  props.setFieldValue("created_on_date", option)
                }
                mt={3}
                label="Date Started"
                name="created_on_date"
              />
              <DateRangePicker
                value={props.values.last_activity_date}
                onChange={(option: any) =>
                  props.setFieldValue("last_activity_date", option)
                }
                mt={3}
                label="Last Activity"
                name="last_activity_date"
              />
              {props.dirty && (
                <Button type="submit" mt="2" size="large" width="100%">
                  Apply
                </Button>
              )}
            </Form>
          )}
        </Formik>
      </Box>
    </Slider>
  );
};
